export const environment = {
  production: false,
  host: '/diasporawallet',
  issuer: 'https://momoremuat.momo.africa',
  authUrl: 'https://momoremuat.momo.africa/',
  tokenUrl: 'https://momoremuat.momo.africa/oauth2/token',
  partnerId: 'c9867648-b8b0-469f-813d-a5c1209939c9',
  redirectUri: 'https://admin-momoremuat.momo.africa',
  logoutUri: 'https://admin-momoremuat.momo.africa/login',
  scope: 'read write openid',
  defaultMobileAccessToken: '256779999613-1789084800000-1793404800000-p0mqvn-1nkyqa9',
  defaultCorrelationId: '540e5e2f-2f0f-496e-8898-bab183afec52'
};
